import script from "./WapEmploymentView.vue?vue&type=script&lang=ts&setup=true"
export * from "./WapEmploymentView.vue?vue&type=script&lang=ts&setup=true"

import "./WapEmploymentView.vue?vue&type=style&index=0&id=726c1cd8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-726c1cd8"]])

export default __exports__